import { Box, useTheme } from '@mui/material'
import { SxProps, Theme } from '@mui/material/styles'
import Crown from '../svg/Crown'

interface FreemiumDotProps {
  sx?: SxProps<Theme>
  size?: number
  showCrown?: boolean
}

export default function FreemiumDot({ sx, size = 8, showCrown }: Readonly<FreemiumDotProps>) {
  const theme = useTheme()
  return (
    <Box
      sx={{
        ...sx,
        borderRadius: 100,
        background: theme.palette.groupsy.gradient,
        minHeight: `${size}px`,
        height: `${size}px`,
        minWidth: `${size}px`,
        width: `${size}px`,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      {showCrown && <Crown color="#FFFFFF" size={size * 0.67} sx={{ display: 'flex', justifyContent: 'center' }} />}
    </Box>
  )
}
